import React, { useState, useContext, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";

import { useSpring, animated } from "react-spring";

import { useScreenTransition } from "../../Hooks/useScreenTransition";

import { AuthContext } from "../../Context/AuthContext";
import { TransitionContext } from "../../Context/TransitionContext";
import { NotificationContext } from "../../Context/NotificationContext";

import { languages } from "../../Data/languages";


import { ReactComponent as DOWN } from "../../assets/icons/filter-down.svg";
import { ReactComponent as SERVICES } from "../../assets/icons/Services.svg";
import { ReactComponent as UP } from "../../assets/icons/filter-up.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import { ReactComponent as CHECK } from "../../assets/icons/check.svg";
import { ReactComponent as SEND } from "../../assets/icons/Send.svg";
import { ReactComponent as PAYMENT } from "../../assets/icons/dollar.svg";
import { ReactComponent as MESSAGE } from "../../assets/icons/Message-icons.svg";
import { ReactComponent as STATUS } from "../../assets/icons/Status.svg";
import { ReactComponent as DATE } from "../../assets/icons/Date.svg";
import { ReactComponent as LANGUAGES } from "../../assets/icons/Languages.svg";
import { ReactComponent as EXPEDITED } from "../../assets/icons/order-expedited.svg";
import { ReactComponent as EXPEDITEDPLUS } from "../../assets/icons/expedited-plus.svg";
import { ReactComponent as HARDCOPY } from "../../assets/icons/order-hard-copy.svg";
import { ReactComponent as NOTRY } from "../../assets/icons/order-notry.svg";
import { ReactComponent as PLACEDBY } from "../../assets/icons/placed-by.svg";
import { ReactComponent as SORT_ASC } from "../../assets/icons/sort-asc.svg";
import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import { ReactComponent as SORT_DSC } from "../../assets/icons/sort-dsc.svg";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import { DataContext } from "../../Context/DataContext";
import NoData from "../../NewComponents/NoData";
import SearchFilter from "../Account/OrdersComponents/SearchFilter";
import LanguageFilter from "../Account/OrdersComponents/LanguageFilter";
import DateFilter from "../Account//OrdersComponents/DateFilter";
import PopUpModal from "../../NewComponents/PopUpModal";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";

import { ReactComponent as CANCELQUOTE } from "../../assets/icons/cancel-quote.svg";
import { ReactComponent as QUOTESUCCESS } from "../../assets/icons/quote-success.svg";
import { QUOTESTATUS } from "../../Data/statuses";
import { formatTotal, getDiscount, getShortOrderNo, getTotal } from "../../Data/Functions";
import "./Quotes.css";
import { auth, checkFetchAlgoliaData, firestore } from "../../firebase.config";
import { getCounter } from "../../Data/Functions/getCounter";
import MessageDot from "../../NewComponents/MessageDot";
import { Configure, Pagination, SearchBox, useHits, useInstantSearch, useSearchBox, useSortBy } from "react-instantsearch-hooks-web";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import Clientsfilter from "../Account/OrdersComponents/Clientsfilter";
import { Link } from "react-router-dom";
import QueryFilters from "../Account/OrdersComponents/QueryFilters";


const QuotesBackendComponent = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();


  const { setColor } = useContext(TransitionContext);
  const { showNotification } = useContext(NotificationContext);
  const { signedIn } = useContext(AuthContext);
  const { userData } = useContext(DataContext);

  const moreOptionsRef = useRef(null);
  const [moreOptions, setMoreOptions] = useState("");
  const [showDetailModal, setShowDetailModal] = useState("");

  const [statusFilter, setStatusFilter] = useState("");
  const [servicesFilter, setServicesFilter] = useState([]);

  const [showFilter, setShowFilter] = useState("");

  const [filterStartTimestamp, setFilterStartTimestamp] = useState(null);
  const [filterEndTimestamp, setFilterEndTimestamp] = useState(null);
  const [selectedLanguageFilter, setSelectedLanguageFilter] = useState({
    languageFrom: "",
    languageTo: "",
  });
  const [datePeriod, setDatePeriod] = useState("custom");

  const [users, setUsers] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);

  const [selectedCancelModal, setSelectedCancelModal] = useState("");
  const [cancelBtnText, setCancelBtnText] = useState("Cancel Quote");
  const [selectedSendPayment, setSelectedSendPayment] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [paylaterBtn, setPaylaterBtn] = useState("Pay Later");

  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState("");
  const [openInvoiceModal, setOpenInvoiceModal] = useState();

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;

  useEffect(() => {
      if(!signedIn || (userData && userData.role === "client")){
        return transitionTo("/");
      }
    }, [signedIn, userData]);

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  const [localQuotes, setLocalQuotes] = useState([]);
    
      useEffect(()=> {
        if(!checkFetchAlgoliaData()){
          if(signedIn && userData.id){
            firestore.collection("quotes").orderBy("timestamp", "desc").get()
            .then(qSnap => {
              if(qSnap.empty){
                return;
              }
    
              setLocalQuotes(qSnap.docs.map(doc => ({...doc.data(), objectID: doc.id})));
            })
          }
        }
    
      }, 
      [userData])

  useEffect(() => {
    if (signedIn && userData) {
      
      firestore
        .collection("users").orderBy("name", "asc")
        .get()
        .then((qSnap) => {
          if (!qSnap.empty) {
            setUsers(qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
          }
        });
    }
  }, [signedIn, userData]);

   useEffect(() => {
     const handleClickOutside = (event) => {
       if (!event.target.closest('.hardCopyAddressIconWrap')) {
         setMoreOptions("");
       }
     };
     document.addEventListener("mousedown", handleClickOutside);
     return () => {
       document.removeEventListener("mousedown", handleClickOutside);
     };
   }, []);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    return splitted[1] + " " + splitted[2] + ", " + splitted[3];
  };

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };


  const formatFilterDate = (date) => {
    return (
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    );
  };

  const getSelectedDateText = () => {
    if (filterStartTimestamp) {
      if (filterEndTimestamp) {
        return (
          formatFilterDate(new Date(filterStartTimestamp)) +
          " - " +
          formatFilterDate(new Date(filterEndTimestamp))
        );
      } else {
        return (
          formatFilterDate(new Date(filterStartTimestamp)) +
          " - " +
          formatFilterDate(new Date())
        );
      }
    } else {
      return "Date";
    }
  };

  const getLanguageLabel = (value) => {
    const language = languages.find((l) => l.value === value);

    if (language) {
      return language.label;
    } else {
      return "";
    }
  };

  const getSelectedLanguage = () => {
    if (
      selectedLanguageFilter.languageFrom !== "" &&
      selectedLanguageFilter.languageTo !== ""
    ) {
      return (
        getLanguageLabel(selectedLanguageFilter.languageFrom) +
        " to " +
        getLanguageLabel(selectedLanguageFilter.languageTo)
      );
    } else {
      return "Languages";
    }
  };

  const checkAnyFilterSelected = () => {
    if (filterStartTimestamp) {
      return true;
    }
    if (filterEndTimestamp) {
      return true;
    }
    if (
      selectedLanguageFilter.languageFrom &&
      selectedLanguageFilter.languageTo
    ) {
      return true;
    }
    if (selectedUsers.length > 0) {
      return true;
    }
    if (servicesFilter.length > 0) {
      return true;
    }
    if (statusFilter !== "") {
      return true;
    }
    return false;
  };

  const handleCancelQuote = () => {
    setCancelBtnText("Cancelling...");

    firestore
      .collection("quotes")
      .doc(selectedCancelModal.id)
      .update({
        status: "cancelled",
      })
      .then(() => {
        setTimeout(() => {
          setCancelBtnText("Cancel Quote");
          setSelectedCancelModal("");
          refresh();
        }, 3000)
      });
  };

  const handlePlaceOrder = async (quoteInfo, paypalID) => {
    setPaylaterBtn("Placing Order...");
    setIsLoading(true);

    const now = new Date();

    let orderNumber = 0;

    await getCounter("order").then((number) => {
      orderNumber = parseInt(number, 10);
      })
    .catch((error) => {
      //console.log(error);
    });

    if (orderNumber === 0) {
      showNotification(
        "Error",
        "An error ocurred while placing the order. Please, try again. If it persists, contact support.",
        "error"
      );
      setPaylaterBtn("Pay Later");
      return false;
    }

    // const addressID = uuidv4();
    const orderID = uuidv4();

    const hardCopyAddress = quoteInfo.hardCopy && quoteInfo.hardCopyExtra;

    const saveNewAddress =
      hardCopyAddress &&
      hardCopyAddress.newAddress &&
      hardCopyAddress.saveAddress;

    const address = hardCopyAddress.newAddress
      ? {
        id: hardCopyAddress.id,
        country: hardCopyAddress.country,
        addressName: hardCopyAddress.addressName,
        firstName: hardCopyAddress.firstName,
        lastName: hardCopyAddress.lastName,
        recipient: hardCopyAddress.firstName + " " + hardCopyAddress.lastName,
        region: hardCopyAddress.region,
        city: hardCopyAddress.city,
        zipCode: hardCopyAddress.zipCode,
        street: hardCopyAddress.street,
        apartment: hardCopyAddress.apartment,
      }
      : signedIn &&
      userData &&
      userData.shipping &&
      userData.shipping.length > 0 &&
      userData.shipping.find((a) => a.id === hardCopyAddress.id);

    const saveNewAddressData = saveNewAddress ? address : "";

    firestore
      .collection("orders")
      .doc(orderID)
      .set({
        orderNumber: orderNumber,
        userID: quoteInfo.userID,
        email: quoteInfo.email,
        name: quoteInfo.name,
        certified: quoteInfo.certified,
        languageFrom: quoteInfo.languageFrom,
        languageTo: quoteInfo.languageTo,
        notarization: quoteInfo.notarization,
        notarizationStatus: quoteInfo.notarization ? "pending" : null,
        expedited: quoteInfo.expedited,
        hardCopy: quoteInfo.hardCopy,
        hardCopyStatus: quoteInfo.hardCopy ? "pending" : null,
        hardCopyExtra:
          quoteInfo.hardCopy && quoteInfo.hardCopyExtra
            ? quoteInfo.hardCopyExtra
            : null,
        pagesCount: quoteInfo.certified ? quoteInfo.pagesCount : 0,
        wordCount: !quoteInfo.certified ? quoteInfo.wordCount : 0,
        notes: quoteInfo.notes,
        files: quoteInfo.files,
        timestamp: now.getTime(),
        status: "new",
        shippingInfo: hardCopyAddress ? address : null,
        paypalOrderID: paypalID,
        discountApplied: quoteInfo.discount > 0,
        discount:
          quoteInfo.discount && quoteInfo.discount > 0 ? quoteInfo.discount : 0,
        teamId: userData.teamId || "",
        totalPrice: getTotal(quoteInfo),
      })
      .then(async () => {
        await firestore.collection("quotes").doc(quoteInfo.id).update({
          status: "ordered",
          orderNumber: orderNumber,
          orderID: orderID,
        });
        if (signedIn && userData && saveNewAddress) {
          handleSaveNewAddress(saveNewAddressData);
        }

        setPaylaterBtn("Pay Later");
        setIsLoading(false);
        setShowSuccessModal(quoteInfo.id);
        refresh();
      })
      .catch((error) => {
        //console.log(error);
        setIsLoading(false);
        setPaylaterBtn("Pay Later");
        showNotification(
          "Error",
          "An error ocurred while placing the order. Please, try again.",
          "error"
        );
      });
  };

  const handleSaveNewAddress = async (address) => {
    if (address) {
      

      const newAddress = { default: false, ...address };

      const mShipping = userData.shipping
        ? userData.shipping.concat([newAddress])
        : [newAddress];

      await firestore
        .collection("users")
        .doc(auth.currentUser.uid)
        .update({
          shipping: mShipping,
        })
        .then(() => { })
        .catch((error) => {
          showNotification(
            "Error",
            "An error ocurred while saving the address. Unfortunately, the address couldn't be saved.",
            "error"
          );
        });
    }
  };

  const handlePopUpClick = (e) => {
    if (signedIn) {
      transitionTo(`/office/quote/${showSuccessModal}`, e);
      return setShowSuccessModal("");
    } else {
      transitionTo("/", e);
      return setShowSuccessModal("");
    }
  };

  const statusOverlayProps = useSpring({
    display: isLoading ? "flex" : "none",
  });


  const goToOrder = (orderId, e) => {
    transitionTo(`/office/translations/${orderId}`, e);
  };

const {hits} = useHits();
const {status, refresh} = useInstantSearch();
const {query} = useSearchBox();
const [loading, setLoading] = useState(true);


const items = [
    {
    Label: "Default",
    value: "quotes"
    },
    {
    Label: "Date asc",
    value: "quote_time_asc"
    },
    {
    Label: "Date dsc",
    value: "quote_time_dsc"
    },
    {
    Label: "Name asc",
    value: "quote_name_asc"
    },
    {
    Label: "Name dsc",
    value: "quote_name_dsc"
    },
    {
    Label: "Client asc",
    value: "quote_client_asc"
    },
    {
    Label: "Client dsc",
    value: "quote_client_dsc"
    },
    {
    Label: "Status asc",
    value: "quote_status_asc"
    },
    {
    Label: "Status dsc",
    value: "quote_status_dsc"
    },
]
const { currentRefinement, refine } = useSortBy({items: items, defaultRefinement: "quote_time_dsc"});

useEffect(() => {
    if(status === "loading" || status === "stalled"){
    setLoading(true);
    }else{
    setLoading(false);
    }
}, [status])

useEffect(() => {
    if(currentRefinement === "quotes"){
    refine("quote_time_dsc");
    }
}, [currentRefinement])


  const [filters, setFilters] = useState("");
  
  useEffect(() => {
    let tempFilters = "";
    
    if(filterStartTimestamp && filterEndTimestamp){
      tempFilters += `${tempFilters === "" ? "" : " AND"} timestamp >= ${filterStartTimestamp} AND timestamp <= ${filterEndTimestamp}`
    }
    if(selectedLanguageFilter && selectedLanguageFilter.languageFrom && selectedLanguageFilter.languageTo){
      tempFilters += `${tempFilters === "" ? "" : " AND"} languageFrom:${selectedLanguageFilter.languageFrom} AND languageTo:${selectedLanguageFilter.languageTo}`;
    }
    if(selectedUsers.length > 0){
      selectedUsers.forEach((email, i) => {
        tempFilters +=`${tempFilters === "" ? "" : (i === 0 ? " AND" : " OR")} email:${email}`
    });
    }
    if (servicesFilter.includes("notry")){
        tempFilters+= `${tempFilters === "" ? "" : " AND"} notarization:true`;
     }
    if (servicesFilter.includes("expedited")){
        tempFilters += `${tempFilters === "" ? "" : " AND"} expedited:true`;
    }
    if (servicesFilter.includes("expedited+")){
        tempFilters += `${tempFilters === "" ? "" : " AND"} expeditedPlus:true`;
    }
    if (servicesFilter.includes("hardCopy")){
        tempFilters+= `${tempFilters === "" ? "" : " AND"} hardCopy:true`;
    }
    if(statusFilter){
      tempFilters+= `${tempFilters === "" ? "" : " AND"} status:${statusFilter}`;
    }

    setFilters(tempFilters);
  }
  , [filterStartTimestamp, filterEndTimestamp, userData, selectedUsers, selectedLanguageFilter, servicesFilter, statusFilter])

  const handleShowMore = (value) => {
    setShowFilter("");
    setMoreOptions(value);
  }


  const TableDataComponent = ({hits }) => {
  
      if(hits.length === 0){
        return <tbody></tbody>;
      }
  
      return (
        <tbody>
        {hits.map(hit =>
        {
          const quote = {...hit, id: hit.objectID}
          return (
              <tr key={quote.id} onClick={(e) => transitionTo(`/office/quote/${quote.id}`, e)}>
                <td>
                  <Link to={`/office/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                    {quote.quoteNumber && quote.quoteNumber.toString().length > 12 &&
                        showDetailModal === quote.quoteNumber && (
                        <div className="accountdetailHoverBox">
                            <p
                            className="quotewidth "
                            >
                            {quote.quoteNumber}
                            </p>
                        </div>
                        )}
                    <p className="quotewidth accountDetailsLink" 
                    onMouseOver={() =>
                        setShowDetailModal(
                        quote.quoteNumber
                        )
                    }
                    onMouseLeave={() => setShowDetailModal("")}>
                    {getShortOrderNo(quote.quoteNumber, "quote")}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}> 
                    <p className="quotewidth">
                    {formatDate(quote.timestamp)}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}> 
                    {quote.name?.length > 14 &&
                        showDetailModal === quote.id + quote.name && (
                        <div className="accountdetailHoverBox">
                            <p
                            className="quotewidth captialLetters"
                            >
                            {quote.name}
                            </p>
                        </div>
                        )}

                    <p
                        className="quoteDetailsText captialLetters overflowText"
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                        setShowDetailModal(quote.id + quote.name)
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                    >
                        {quote.name}
                    </p>
                  </Link>
                </td>
                
                <td>
                  <Link to={`/office/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}> 
                    {quote.email?.length > 14 &&
                        showDetailModal ===
                        quote.id + quote.email && (
                        <div className="accountdetailHoverBox">
                            <p
                            className="quoteDetailsText lowercaseLetter"

                            >
                            {quote.email}
                            </p>
                        </div>
                        )}
                    <p
                        className="quoteDetailsText lowercaseLetter overflowText"
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                        setShowDetailModal(quote.id + quote.email)
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                    >
                        {quote.email}
                    </p>
                  </Link>
                </td>
                
                <td>
                  <Link to={`/office/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}> 
                    {showDetailModal ===
                    quote.id + quote.languageFrom && (
                        <div className="accountdetailHoverBox">
                        <p
                            className="quotewidth captialLetters"
                        >
                            {getLanguage(quote.languageFrom) +
                            " / " +
                            getLanguage(quote.languageTo)}
                        </p>
                        </div>
                    )}
                    <p
                    className="quotewidth"
                    style={{
                        textTransform: "uppercase",
                        cursor: "pointer",
                    }}
                    onMouseOver={() =>
                        setShowDetailModal(
                        quote.id + quote.languageFrom
                        )
                    }
                    onMouseLeave={() => setShowDetailModal("")}
                    >
                    {getLanguage(quote.languageFrom).substr(0, 2) +
                        "/" +
                        getLanguage(quote.languageTo).substr(0, 2)}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}> 
                    {showDetailModal === quote.id + "N" && (
                    <div className="accountdetailHoverBox">
                        <p
                        className="quotewidth captialLetters"
                        >
                        Notarization
                        </p>
                    </div>
                    )}
                    {showDetailModal === quote.id + "E" && (
                    <div className="accountdetailHoverBox">
                        <p
                        className="quotewidth captialLetters"
                        >
                        {quote.expeditedPlus
                            ? "Expedited+ Turnaround"
                            : "Expedited Turnaround"}
                        </p>
                    </div>
                    )}
                    {showDetailModal === quote.id + "H" && (
                    <div className="accountdetailHoverBox">
                        <p
                        className="quotewidth captialLetters"
                        >
                        Mail Hard Copy
                        </p>
                    </div>
                    )}
                    <p className="quotewidth captialLetters flex gap-1">
                      <p className="opacity-0">.</p>
                    {quote.notarization && (
                        <NOTRY
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(quote.id + "N")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    )}
                    {quote.expedited && (
                        <EXPEDITED
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(quote.id + "E")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    )}
                    {quote.expeditedPlus && (
                        <EXPEDITEDPLUS
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(quote.id + "E")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    )}
                    {quote.hardCopy ? (
                        <HARDCOPY
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(quote.id + "H")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    ) : (
                        ""
                    )}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}> 
                    <MessageDot chatId={quote.generalChatId}/>
                    <MessageDot chatId={quote.everbaryChatId} type="everbary"/>
                    {/* <FileCommentIndicator orderId={quote.id} /> */}
                  </Link>
                </td>

                <td>
                  <Link to={`/office/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}> 
                    <p
                    className="quotewidth accountDetailsStatus "
                    style={{
                        backgroundColor: QUOTESTATUS[quote.status]
                        ? QUOTESTATUS[quote.status][1]
                        : "",
                    }}
                    >
                    {QUOTESTATUS[quote.status]
                        ? QUOTESTATUS[quote.status][0]
                        : ""}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}> 
                    <p className="quotewidth">
                    { formatTotal(
                        getTotal(quote)- getDiscount(quote)
                        )}
                    </p>
                  </Link>
                </td>
                <td >
                    {quote.status === "replied" ? (
                    <p className="replied">
                        <button
                        className="sendPaymentLink p-0"
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedSendPayment(quote);
                        }}
                        >
                        <SEND />
                        </button>
                    </p>
                    ) : (
                    <p
                        onClick={(e) =>
                        transitionTo(`/office/quote/${quote.id}`, e)
                        }
                        className="replied" 
                    >
                        {quote.status === "ordered" ? (
                        <CHECK />
                        ) : quote.status === "cancelled" ? (
                        "Cancelled"
                        ) : (
                        "-"
                        )}
                    </p>
                    )}
                </td>
                <td onClick={(e) => e.stopPropagation()}>
                    {
                    <div
                        className="hardCopyAddressIconWrap "
                        ref={moreOptionsRef}
                        tabIndex={0} // Enables blur event for accessibility
                    >
                        {moreOptions === quote.id ? (
                        <MORESELECTED
                            className="hardCopyAddressIcon"
                        onClick={() => handleShowMore("")}
                        />
                        ) : (
                        <MORE
                            className="hardCopyAddressIcon"
                            onClick={(e) => {
                            e.stopPropagation(); // Prevents event bubbling
                            handleShowMore(quote.id);
                            }}
                        />
                        )}

                        {quote.status === "ordered" &&
                        moreOptions === quote.id && (
                            <div className="hardCopyAddressEditWrap">
                            {/* {<div className="hardCopyAddressEdit" onClick={() => { setSelectedCancelModal({ id: quote.id, quoteNumber: quote.quoteNumber }) }}>Cancel Quote</div>} */}
                            {quote.orderID && (
                                <div
                                className="hardCopyAddressEdit"
                                onClick={(e) => {
                                    goToOrder(quote.orderID, e);
                                }}
                                >
                                Go To The Order
                                </div>
                            )}
                            </div>
                        )}

                        {(quote.status === "submitted" ||
                        quote.status === "replied") &&
                        moreOptions === quote.id && (
                            <div className="hardCopyAddressEditWrap">
                            {
                                <div
                                className="hardCopyAddressEdit"
                                onClick={() => {
                                    setSelectedCancelModal({
                                    id: quote.id,
                                    quoteNumber: quote.quoteNumber,
                                    });
                                }}
                                >
                                Cancel Quote
                                </div>
                            }
                            {quote.orderID && (
                                <div
                                className="hardCopyAddressEdit"
                                onClick={(e) => {
                                    goToOrder(quote.orderID, e);
                                }}
                                >
                                Go To The Order
                                </div>
                            )}
                            
                            </div>
                        )}
                    </div>
                    }
                </td>
                </tr>
              )
        })}
      </tbody>
      )
    }


return (
    <>
      <Configure filters={filters} hitsPerPage={20}/>
    {openInvoiceModal && <OpenInvoiceModal type="invoice" order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}
    
    <QueryFilters
        setFilterStartTimestamp={setFilterStartTimestamp}
        filterStartTimestamp={filterStartTimestamp}
        setFilterEndTimestamp={setFilterEndTimestamp}
        filterEndTimestamp={filterEndTimestamp}
        setDatePeriod={setDatePeriod}
        datePeriod={datePeriod}
        setStatusFilter={setStatusFilter}
        statusFilter={statusFilter}
        setServicesFilter={setServicesFilter}
        servicesFilter={servicesFilter}
        setSelectedClients={setSelectedUsers}
        selectedClients={selectedUsers}
        setSelectedLanguageFilter={setSelectedLanguageFilter}
        selectedLanguageFilter={selectedLanguageFilter}
        baseUrl="/office/quotes"
      />
    
     <animated.div
        style={statusOverlayProps}
        className="checkoutStatusOverlay"
      >
        We are finishing up. Please wait, this will take a second<span className="dotsLoading">...</span>
      </animated.div>
      {selectedPayment && (
        <PopUpModal
          title={"Create Order From The Quote"}
          backBtnText={paylaterBtn}
          subText=""
          text={"Do you want to pay for the newly created order now?"}
          btnText={"Pay Now"}
          hideIcon
          alignLeft
          showClose
          onClose={() => setSelectedPayment("")}
          onClick={(e) =>
            transitionTo(`/make-payment/quote/${selectedPayment.id}`, e)
          }
          onBackClick={() => {
            handlePlaceOrder(selectedPayment, "pay-later");
          }}
          disableBtn={cancelBtnText === "Cancelling..."}
        ></PopUpModal>
      )}
      {selectedCancelModal !== "" && (
        <PopUpModal
          title={"Cancel Quote"}
          backBtnText="Back to Quotes"
          subText="Are you sure you want to cancel this quote?"
          text={(selectedCancelModal.quoteNumber)}
          btnText={cancelBtnText}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => setSelectedCancelModal("")}
          onClick={() => handleCancelQuote()}
          onBackClick={() => {
            setSelectedCancelModal("");
          }}
          disableBtn={cancelBtnText === "Cancelling..."}
        >
          <CANCELQUOTE />
        </PopUpModal>
      )}
      {showSuccessModal && (
        <PopUpModal
          title="Quota has been converted into the order"
          btnText="Ok"
          onClick={(e) => handlePopUpClick(e)}
          text="You can track the status of the order on the orders page in your account"
        >
          {<QUOTESUCCESS />}
        </PopUpModal>
      )}

      {selectedSendPayment !== "" && (
        <SendPaymentLinkPopUp
          data={selectedSendPayment}
          type="quote"
          id={selectedSendPayment.id}
          onClose={() => setSelectedSendPayment("")}
        />
      )}
    
    <AccountNavBar
    showButton={true}
    windowSize={windowSize}
    selectedTab="quotes"
    accountMainPadding={false}
    admin={true}
    >
    <div className="accountMainTitleRow px-5 pt-5">
        <h2 className="accountMainTitle">Quotes</h2>
        
        <SearchBox classNames={{
        root: "newSearchbox",
        form: "newSearchbox_form",
        input: "newSearchbox_input",
        reset: "hidden",
        loadingIndicator: "hidden",
        }} 
        placeholder="Search By ID, Client or Request By" 
        submitIconComponent={() => <SEARCHICON/>} />
    </div>

     {/* <div className="w-full flex justify-end px-4">
            <NewButton
            text="Create Quote"
            onClick={(e) => transitionTo("/manualQuote/create")}
            back
            icon={false}
            whiteBtn
            width="150px"
            />
        </div> */}

    {/* <div className="w-full flex lg:flex-row lg:justify-between items-center flex-col gap-4 px-2"> */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 lg:w-fit w-full px-4 gap-4">
            <div className="relative">
            <div
                className="accountDetailsFilter"
                style={{
                borderColor:
                    showFilter === "date" ||
                    filterStartTimestamp ||
                    filterEndTimestamp
                    ? "#12ABBF"
                    : "#E6E7E9",
                }}
                onClick={(e) => {
                setShowFilter((f) => (f === "date" ? "" : "date"));
                }}
            >
                <DATE />
                <p className="accountDetailsFilterText">
                {getSelectedDateText()}
                </p>
                {showFilter === "date" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "date" && (
                <DateFilter
                setShowModal={setShowFilter}
                startTimestamp={filterStartTimestamp}
                setStartTimestamp={setFilterStartTimestamp}
                endTimestamp={filterEndTimestamp}
                setEndTimestamp={setFilterEndTimestamp}
                period={datePeriod}
                setPeriod={setDatePeriod}
                />
            )}
            </div>
            <div className="relative">
                <div
                className="accountDetailsFilter"
                style={{
                    borderColor:
                    showFilter === "placedBy" || selectedUsers.length > 0
                        ? "#12ABBF"
                        : "#E6E7E9",
                }}
                onClick={(e) => {
                    setShowFilter((f) =>
                    f === "placedBy" ? "" : "placedBy"
                    );
                }}
                >
                <PLACEDBY />
                <p className="accountDetailsFilterText">
                    Requested by{" "}
                    {selectedUsers.length > 0
                    ? ` (${selectedUsers.length}) `
                    : ""}
                </p>
                {showFilter === "placedBy" ? <UP /> : <DOWN />}
                </div>
                {showFilter === "placedBy" && (
                <Clientsfilter
                    setShowModal={setShowFilter}
                    clients={users}
                    setSelectedClients={setSelectedUsers}
                    selectedClients={selectedUsers}
                />
                )}
            </div>
            <div className="relative">
            <div
                className="accountDetailsFilter"
                style={{
                borderColor:
                    showFilter === "language" ||
                    (selectedLanguageFilter.languageFrom !== "" &&
                        selectedLanguageFilter.languageFrom !== "")
                    ? "#12ABBF"
                    : "#E6E7E9",
                }}
                onClick={(e) => {
                setShowFilter((f) => (f === "language" ? "" : "language"));
                }}
            >
                <LANGUAGES />
                <p className="accountDetailsFilterText">
                {getSelectedLanguage()}
                </p>
                {showFilter === "language" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "language" && (
                <LanguageFilter
                setShowModal={setShowFilter}
                setSelectedLanguageFilter={setSelectedLanguageFilter}
                selectedLanguageFilter={selectedLanguageFilter}
                />
            )}
            </div>
            <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "services" || servicesFilter.length > 0
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "services" ? "" : "services"));
            }}
            >
            <SERVICES />
            <p className="accountDetailsFilterText">
                Services
                {/* {servicesFilter.length > 0
                ? ` (${servicesFilter.length}) `
                : ""} */}
            </p>
            {showFilter === "services" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "services" && (
            <SearchFilter
                type="services"
                setStatusFilter={setServicesFilter}
                selectedFilters={servicesFilter}
                setShowModal={setShowFilter}
            />
            )}
        </div>
            <div className="relative">
            <div
                className="accountDetailsFilter"
                style={{
                borderColor:
                    showFilter === "status" || statusFilter !== ""
                    ? "#12ABBF"
                    : "#E6E7E9",
                }}
                onClick={(e) => {
                setShowFilter((f) => (f === "status" ? "" : "status"));
                }}
            >
                <STATUS />
                <p className="accountDetailsFilterText">
                    Status
                </p>
                {showFilter === "status" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "status" && (
                <SearchFilter
                quote={true}
                type="status"
                setStatusFilter={setStatusFilter}
                selectedFilters={statusFilter}
                setShowModal={setShowFilter}
                isLast={true}
                />
            )}
            </div>
        </div>
       
    {/* </div> */}


    <div className="accountDetailsScroll w-full">
        {loading ? <NoData loadingText={"quotes"} loading={true} showBtn={false} type="quote"/> :
        (!checkFetchAlgoliaData() ? localQuotes.length === 0 : hits.length === 0)  &&
        <NoData
        type="order"
        text={checkAnyFilterSelected() || query !== "" ? "Please select another filter" : ""}
        title={checkAnyFilterSelected() || query !== "" ? "No Quote Matching This Filter": "You Don't Have Any Active Quote Yet"}
        showBtn={false}
        /> }
        {(!checkFetchAlgoliaData() ? localQuotes.length > 0 : hits.length > 0) && !loading &&
        <table className="accountDetailsTable" style={{display: loading ? "none" : "table"}}>
        <thead>
            <tr>
                <th>
                <p className="accountDetailsHeading">ID</p>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Submitted</p>
                    { currentRefinement === "quote_time_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("quote_time_asc")}/> 
                    : currentRefinement === "quote_time_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("quote_time_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("quote_time_dsc")}/>
                    }
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Requested by</p>
                    { currentRefinement === "quote_name_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("quote_name_asc")}/> 
                    : currentRefinement === "quote_name_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("quote_name_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("quote_name_dsc")}/>
                    }
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Сlient email</p>
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Languages</p>
                </div>
                </th>

                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Services</p>
                </div>
                </th>
                <th>
                <div className="accountData">
                    {showDetailModal === "add-comment" && (
                    <div className="accountdetailHoverBox addCommentHover">
                        <p className="quoteDetailsText">Chat</p>
                    </div>
                    )}
                    <MESSAGE
                    style={{ cursor: "pointer" }}
                    onMouseOver={() => setShowDetailModal("add-comment")}
                    onMouseLeave={() => setShowDetailModal("")}
                    />
                </div>
                </th>

                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Status</p>
                    { currentRefinement === "quote_status_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("quote_status_asc")}/> 
                    : currentRefinement === "quote_status_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("quote_status_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("quote_status_dsc")}/>
                    }
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Total</p>
                </div>
                </th>

                <th>
                {showDetailModal ===
                    "Payment" && (
                    <div className="accountdetailHoverBox top-9">
                        <p
                        className="quoteDetailsText captialLetters"
                        >
                        Payment
                        </p>
                    </div>
                    )}
                <div
                    className="accountData"
                    style={{ justifyContent: "center", maxWidth: "170px" }}
                >
                    <PAYMENT style={{ cursor: "pointer" }}
                    onMouseOver={() =>
                        setShowDetailModal("Payment")
                    }
                    onMouseLeave={() => setShowDetailModal("")} />
                </div>
                </th>
                <th></th>
            </tr>
            </thead>

            <TableDataComponent hits={!checkFetchAlgoliaData() ? localQuotes : hits}/>

        </table>}
            {hits.length > 0 && 
            <Pagination
            padding={0}
            showFirst={false}
            showPrevious={true}
            showNext={true}
            showLast={false}
            classNames={{
                root: "w-full my-4 mx-2",
                list: "w-full flex justify-center items-center gap-2",
                item: "",
                selectedItem:"",
                disabledItem:"opacity-50 cursor-not-allowed",
                previousPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                nextPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                firstPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                lastPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
            }}
            translations={{
            previousPageItemText: 'Previous',
            nextPageItemText: 'Next',
            pageItemText: ({ currentPage, nbPages }) => `Page ${currentPage}`,
            previousPageItemAriaLabel: 'Go to previous page',
            nextPageItemAriaLabel: 'Go to next page',
            pageItemAriaLabel: ({ currentPage, nbPages }) => `Go to page ${currentPage} of ${nbPages}`,
            }}
            />}
    </div>
    
    </AccountNavBar>
    </>

)
  
};

export default QuotesBackendComponent;
